//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../axios/axios.js'
import ServerFilter from '../ServerFilter/ServerFilter.vue'
import TableServer from '../../components/Table/Table.vue'

export default {
  name: 'TableComponentServerSingleWithFilter',
  components: {
    ServerFilter,
    TableServer
  },
  props: {
    headerLabel: {
      type: String,
      default: 'Выбор объекта'
    },
    store: {
      type: Object,
      default: null
    },
    items: {
      type: Array,
      default: function () {
        return []
      }
    },
    urlBase: {
      type: String,
      default: null
    },
    additionalUrlParams: {
      type: Object,
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    selectedItem: {
      type: Object,
      default: function () {
        return {}
      }
    },
    selectedItems: {
      type: Array,
      default: null
    },
    qTableClass: {
      type: String,
      default: ''
    },
    bordered: {
      type: Boolean,
      default: false
    },
    selectedItemsIds: {
      type: Array,
      default () {
        return []
      }
    },
    primaryKey: {
      type: String,
      default: 'id'
    },
    columns: {
      type: Array,
      default: null
    },
    filterType: {
      type: String,
      default: null
    },
    filterName: {
      type: String,
      default: 'ФИЛЬТР'
    },
    formId: {
      type: String,
      default: null
    },
    toolbarHidden: {
      type: Boolean,
      default: false
    },
    configurable: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    headerHidden: {
      type: Boolean,
      default: false
    },
    autoUpdate: {
      type: Boolean,
      default: true // TODO false (Table.vue)
    },
    autoUpdateTimeout: {
      type: Number,
      default: 60000
    },
    hideButtonPanel: {
      type: Boolean,
      default: false
    },
    trClassFn: {
      type: Function,
      default () {
        return null
      }
    },
    notSaveScroll: {
      type: Boolean,
      default: false
    },
    enableSearchFieldModes: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      splitterVerticalModel: 70,
      splitterHorizontal: 65,
      selectedRecord: null,

      filterUnavailable: false,
      filterOpened: false,
      filterEmpty: false
    }
  },
  computed: {
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    },
    filterTypeLocal: function () {
      return this.filterType || (this.store.proxy && this.store.proxy.filterType) || ''
    },
    formIdLocal: function () {
      return this.formId || (this.store.proxy && this.store.proxy.formId) || null
    },
    displayFilterSection: function () {
      return !this.mobile && this.hasFilter
    },
    displayFilterDialog: function () {
      return this.mobile && this.hasFilter
    },
    hasFilter: function () {
      return !!this.filterTypeLocal
    },
    columnsLocal: function () {
      if (this.columns && this.columns.length) {
        return this.columns
      }
      return [
        {
          name: 'name',
          searchable: true,
          label: 'Название',
          align: 'left',
          defaultWidth: 130,
          field: 'name',
          sortable: true
        }
      ]
    },
    searchColumnsLocal: function () {
      if (this.columnsLocal && this.columnsLocal.length) {
        const searchColumnsNames = []
        this.columnsLocal.forEach(column => {
          if (column.searchable) {
            searchColumnsNames.push(column.name)
          }
        })
        if (searchColumnsNames.length) {
          return searchColumnsNames
        }
      }
      return null
    }
  },
  created: function () {
    if (!this.displayFilterSection) {
      this.onHideFilter()
    }
    if (this.displayFilterDialog) {
      this.updateFilterEmpty()
    }
  },
  mounted: function () {
    if (!this.$slots['under-table']) {
      this.splitterHorizontal = 100
    }
  },
  methods: {
    onItemSelected: function (item) {
      this.$emit('selected-item', item)
    },
    onHideFilter: function () {
      this.splitterVerticalModel = 100
    },
    onDisplayFilter: function () {
      this.splitterVerticalModel = 70
    },
    updateFilterEmpty: function () {
      if (this.filterTypeLocal && this.filterTypeLocal !== '') {
        axiosGet({
          url: `/service/delta/dispatcher/isfilterempty?type=${this.filterTypeLocal}&formId=${this.formIdLocal}`,
          onSuccess: (response) => {
            this.filterEmpty = response.data.result
          },
          onFailure: 'Ошибка получения состояния фильтра'
        })
      } else {
        this.filterEmpty = true
      }
    }
  }
}

